export default class SelectBox {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.select-box'), el => {
			new SelectBox(el);
		});
	}

	isOpen = false;
	classes = {
		node: 'select-box',
		open: 'select-box--is-open',
        list: 'select-box__options-list',
		option: 'select-box__option',
		optionSelected: 'select-box__option--is-selected',
        optionSelectedTitle: 'select-box__option-title',
		optionLabel: 'select-box__option-label',
		optionsInput: 'select-box__option input'
	}

	constructor(element) {
        if (!element) return;
		this.element = element;
        this.list = this.element.querySelector(`.${this.classes.list}`);
        this.selected = this.element.querySelector(`.${this.classes.optionSelected}`);
        this.placeholder = this.element.dataset && this.element.dataset.placeholder ? this.element.dataset.placeholder : this.selected.innerText;
		this.optionsInput = this.element.querySelectorAll(`.${this.classes.optionsInput}`);
        this.value = this.element.dataset.value || '';

        if (element.dataset.value) {
            const selected = this.getOptionByValue(element.dataset.value);
            if (selected) {
                this.select(selected);
            }
        }

		// link handler
		window.addEventListener('click', (e) => {
            const target = e.target;

            // link handler
			if (target.dataset && target.dataset.type === 'form-link') {
                e.preventDefault();
                e.stopPropagation();

                if (!target.dataset.select) return;

                this.select(this.getOptionByValue(target.dataset.select));
                this.close();
            }

            if (!this.element.contains(target) && this.isOpen) {
                // close when clicking outside on a open select
                this.close();
                return;
            }

            if (!this.element.contains(target)) {
                return;
            }

            // select handler
			const option = target.classList.contains(this.classes.option) ? target : false;
            const optionIsSelected = target.classList.contains(this.classes.optionSelected);

			if (optionIsSelected) {
				if (this.isOpen) {
                    this.close();
                } else {
                    this.open();
                }
                return;
			}

			if (option && !optionIsSelected) {
				this.select(option);
				this.close();
			}
		});

        this.optionsInput.forEach(el => {
            el.addEventListener('change', () => {
                this.select(el.closest(`.${this.classes.option}`));
            })
        })
	}

	open() {
		this.isOpen = true;
		this.element.classList.add(this.classes.open);
	}

	close() {
        document.activeElement.blur();
		this.isOpen = false;
		this.element.classList.remove(this.classes.open);
	}

    clear() {
        this.value = '';
        Array.from(this.optionsInput).map(el => el.checked = false);
        this.selected.querySelector(`.${this.classes.optionSelectedTitle}`).innerHTML = this.placeholder;
    }

	select(option) {
		let selectedContainer = this.element.querySelector(`.${this.classes.optionSelected}`);
		option.querySelector('input').checked = true;
        this.value = option.querySelector('input').value;
		selectedContainer.querySelector(`.${this.classes.optionLabel}`).innerHTML = option.querySelector(`.${this.classes.optionLabel}`).innerHTML;
        const changeEvent = new CustomEvent('change', {
            detail: {
                value: option.querySelector('input').value
            }
        });
        this.element.dispatchEvent(changeEvent);
    }

	getSelected() {
		return Array.prototype.find.call(this.optionsInput, el => el.checked);
	}

	getOptionByValue(value) {
		return Array.prototype.find.call(this.optionsInput, el => el.value === value.toString()).closest(`.${this.classes.option}`);
	}
}
